import { t } from "i18next";
import * as yup from "yup";

export const newOfferValidationSchema = () =>
  yup.object().shape({
    offerContent: yup
      .string()
      .min(3, t("offerContnet.valiation.mustNotBeLessThan3")!)
      .max(300, t("offerContnet.valiation.mustNotExceed300")!)
      .required(t("offerContnet.valiation.required")!),
    imageFile: yup.string().required(t("image.valiation.required")!),
  });
